import { useEffect, useState } from "react";
import { ShieldAlert, Lock } from "lucide-react";
import { api } from "@/api/client";

/* Founder Preview Sandbox banner — shown on the dashboard whenever AUSTRAC_LIVE is
   false. Founder sees "data collection live for you only"; everyone else sees the
   public-launch-pending notice. Reads the ungated /compliance-gate/status probe. */
export default function AustracSandboxBadge({ isFounder = false }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/compliance-gate/status")
      .then((r) => { if (alive) setStatus(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!status || !status.sandbox) return null;

  return (
    <div
      data-testid="austrac-sandbox-badge"
      className={[
        "-mx-4 -mt-5 mb-4 px-4 py-3 border-b-2 flex items-start gap-3",
        isFounder
          ? "bg-[#FFCC00]/10 border-[#FFCC00]/50"
          : "bg-red-500/10 border-red-500/40",
      ].join(" ")}
    >
      <div className={[
        "shrink-0 grid place-items-center w-8 h-8 rounded-lg border-2",
        isFounder ? "border-[#FFCC00]/60 text-[#FFCC00]" : "border-red-500/50 text-red-400",
      ].join(" ")}>
        {isFounder ? <ShieldAlert size={16} /> : <Lock size={16} />}
      </div>
      <div className="min-w-0">
        <p className={[
          "font-black uppercase tracking-widest text-[10px]",
          isFounder ? "text-[#FFCC00]" : "text-red-300",
        ].join(" ")} data-testid="austrac-sandbox-title">
          Founder Preview Sandbox
        </p>
        <p className="text-zinc-300 text-[11px] leading-relaxed mt-0.5" data-testid="austrac-sandbox-copy">
          {isFounder
            ? "Data collection, banking links & KYC are LIVE for your Founder account only. Public access opens the moment AUSTRAC compliance clears."
            : "Data-collection, banking & KYC features are locked until AUSTRAC compliance clearance. Everything else is fully available."}
        </p>
      </div>
    </div>
  );
}
